// extracted by mini-css-extract-plugin
export default {"autoComplete":"RU-z","error":"SU-z","disabled":"TU-z"};